import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimExcludeAllObjectsFromWorkOrderMutation } from 'gql/graphql';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { bimExcludeAllObjectsFromWorkOrderGql } from '../../bimWorkOrderQueries';

import { useResetWorkOrderFiltersWithStructureOps } from './useOnSuccessStructureOps';

const requestId = 'bimExcludeAllObjectsFromWorkOrder';

export const useBimExcludeAllObjectsFromWorkOrder = (workOrderId: number | undefined, onSuccess: () => any) => {
    const dispatch = useDispatch();

    const [bimExcludeAllObjectsFromWorkOrderReset] = useResetStoreData({ requestId });
    const { makeResetWorkOrderObjectFilter } = useResetWorkOrderFiltersWithStructureOps();

    const onSuccessWithWorkOrderObjReset = useCallback(
        ({ payload }: { payload: BimExcludeAllObjectsFromWorkOrderMutation }) => {
            makeResetWorkOrderObjectFilter(payload?.bimExcludeAllObjectsFromWorkOrder?.data);
            onSuccess();
        },
        [makeResetWorkOrderObjectFilter, onSuccess],
    );

    const [
        bimExcludeAllObjectsFromWorkOrderData,
        bimExcludeAllObjectsFromWorkOrderStatus,
        bimExcludeAllObjectsFromWorkOrderError,
        bimExcludeAllObjectsFromWorkOrderRequest,
    ] = useRequest({
        requestId,
        query: bimExcludeAllObjectsFromWorkOrderGql,
        withEffect: false,
        dependenciesUpdater: onSuccessWithWorkOrderObjReset,
    });

    const bimExcludeAllObjectsFromWorkOrderMakeRequest = useCallback(
        (constructionTypeId: number) => {
            dispatch(bimExcludeAllObjectsFromWorkOrderRequest({ constructionTypeId, workOrderId }));
        },
        [bimExcludeAllObjectsFromWorkOrderRequest, dispatch, workOrderId],
    );

    useEffect(() => {
        bimExcludeAllObjectsFromWorkOrderReset(undefined);
    }, [bimExcludeAllObjectsFromWorkOrderReset]);

    return {
        bimExcludeAllObjectsFromWorkOrderData,
        bimExcludeAllObjectsFromWorkOrderStatus,
        bimExcludeAllObjectsFromWorkOrderError,
        bimExcludeAllObjectsFromWorkOrderMakeRequest,
    };
};
